const { COMPANY_NAME } = require('./constants');
const {
    DOMAIN_LETSTAY,
    DOMAIN_HTZ,
    DOMAIN_ELAL_TRAVEL,
    DOMAIN_ELAL_APPLICATION,
    DOMAIN_ISRACARD,
    DOMAIN_ISRACARD_DEV,
    DOMAIN_AIRHAIFA_STAGING,
    DOMAIN_AIRHAIFA,
} = require('./domains');

const developmentCompanyIds = {
    '5c60469aff5cd815748df923': COMPANY_NAME.HTZ,
    '6693dc362a605ba17f95b265': COMPANY_NAME.HTZ,
    '667bbca297a422cbd5abfa9b': COMPANY_NAME.LS,
    '68fe0a8785a596359e41464b': COMPANY_NAME.ELAL, // ELAL Partner DEV
    '693ecde8000f3e3a074303c8': COMPANY_NAME.ELAL, // El Al Loyalty
    '69b1388ccc7fe223f0a8a599': COMPANY_NAME.ISRACARD,
    '6865242dc802c9479b0c048c': COMPANY_NAME.ELAL, // Oleksii El_AL
    '6a16ead624724e22f034c91b': COMPANY_NAME.AIRHAIFA
};

const productionCompanyIds = {
    '6704e871022c6aec954dc5a3': COMPANY_NAME.HTZ,
    '66f2bf384d1a7164b76fb307': COMPANY_NAME.LS,
    '6836e1eed06cc5a8f687d80d': COMPANY_NAME.LS,
    '6942821046d86c9d169138d0': COMPANY_NAME.ELAL, // ELAL Partner
    '699ddaa53a48e06b9f509cf3': COMPANY_NAME.ELAL, // ELAL TEMP
    '69faeef747e11a1af43f75e9': COMPANY_NAME.ISRACARD,
    '6a54ec919b1e0eecce5009ed': COMPANY_NAME.AIRHAIFA
};

const HOSTNAME_DOMAINS = {
    [COMPANY_NAME.HTZ]: [DOMAIN_HTZ],
    [COMPANY_NAME.LS]: [DOMAIN_LETSTAY],
    [COMPANY_NAME.ELAL]: [DOMAIN_ELAL_TRAVEL, DOMAIN_ELAL_APPLICATION],
    [COMPANY_NAME.ISRACARD]: [DOMAIN_ISRACARD, DOMAIN_ISRACARD_DEV],
    [COMPANY_NAME.AIRHAIFA]: [DOMAIN_AIRHAIFA_STAGING, DOMAIN_AIRHAIFA],
    // [COMPANY_NAME.ELAL]: [DOMAIN_ELAL_TRAVEL, DOMAIN_ELAL_APPLICATION, 'localhost'], // localhost added for testing
};

/**
 * Gets the hostname from browser context
 * @returns {string|null} - Hostname if available, null otherwise
 */
function getHostname() {
    if (typeof window !== 'undefined' && window.location) {
        return window.location.hostname;
    }
    if (typeof document !== 'undefined' && document.location) {
        return document.location.hostname;
    }
    return null;
}

/**
 * Gets company name from hostname by performing reverse lookup of HOSTNAME_DOMAINS
 * @param {string} hostname - The hostname to check (e.g., "travel.elal.com", "app.travel.elal.com")
 * @returns {string|null} - Company name if match found, null otherwise
 */
function getCompanyNameFromDomain(hostname) {
    if (!hostname || typeof hostname !== 'string') {
        return null;
    }

    // Iterate through HOSTNAME_DOMAINS to find matching company
    for (const [companyName, domains] of Object.entries(HOSTNAME_DOMAINS)) {
        for (const domain of domains) {
            // Exact match
            if (hostname === domain) {
                return companyName;
            }
            // Subdomain match (e.g., "app.travel.elal.com" matches "travel.elal.com")
            if (hostname.endsWith('.' + domain)) {
                return companyName;
            }
        }
    }

    return null;
}

/**
 * Gets company name from current hostname (browser context)
 * @returns {string|null} - Company name if match found, null otherwise
 */
function getCompanyNameFromHostname() {
    const hostname = getHostname();
    if (!hostname) {
        return null;
    }
    return getCompanyNameFromDomain(hostname);
}

module.exports = {
    ...developmentCompanyIds,
    ...productionCompanyIds,
    HOSTNAME_DOMAINS,
    getHostname,
    getCompanyNameFromDomain,
    getCompanyNameFromHostname,
};
